"use client";
import { jsxs as o, jsx as l } from "react/jsx-runtime";
const i = ({
  title: a,
  titleId: c,
  desc: r,
  descId: h,
  ...n
}) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": c,
    "aria-describedby": h,
    ...n,
    children: [
      r ? /* @__PURE__ */ l("desc", { id: h, children: r }) : null,
      a ? /* @__PURE__ */ l("title", { id: c, children: a }) : null,
      /* @__PURE__ */ l(
        "path",
        {
          fill: "none",
          d: "M26.2747 44.0012h-22.8c.31-.56 4.55-8.11 7.77-13.85 1.9199-3.42 3.48-6.2 3.64-6.48 1.4 2.51 2.5399 4.53 3.4498 6.15 2.58 4.63 3.3801 6.05 3.58 6.4 0 0 0 .02.01.02q.015.045.0301.06c.01.02.02.03.02.03z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M26.2744 44.751H3.4746a.75.75 0 0 1-.6562-1.1133c.1928-.3486 1.9057-3.3994 3.9482-7.039l4.8545-8.6495c1.4243-2.538 2.482-4.4219 2.6123-4.6504a.751.751 0 0 1 .6514-.3779h.0039a.75.75 0 0 1 .6513.3848c1.0337 1.8545 1.9258 3.4404 2.688 4.7959l.7603 1.3525c2.579 4.628 3.3784 6.046 3.5781 6.3965a.5.5 0 0 1 .0166.0313c.0073.0136.0147.0273.021.042a.6.6 0 0 1 .025.04l4.2997 7.6699a.751.751 0 0 1-.0073.746.75.75 0 0 1-.647.3712m-21.5205-1.5h20.2402l-3.6552-6.5195a.88.88 0 0 1-.0957-.1739c-.2305-.4053-1.0596-1.878-3.564-6.371l-.7583-1.3497a1366 1366 0 0 1-2.0386-3.6328c-.4687.834-1.1528 2.0527-1.953 3.4785L8.0746 37.333c-1.3804 2.46-2.6103 4.6504-3.3208 5.918m17.8706-7.2871.001.002z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M48.25 44.749H1.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h46.5c.414 0 .75.336.75.75s-.336.75-.75.75M32.0981 19.75c-.414 0-.75-.336-.75-.75V6.373c0-.414.336-.75.75-.75s.75.336.75.75V19c0 .414-.3359.75-.75.75"
        }
      ),
      /* @__PURE__ */ l("path", { fill: "none", d: "M40.122 12.0868h-8.024V5.999h8.024l-1.4918 3.0238z" }),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M40.122 12.837h-8.0239c-.414 0-.75-.336-.75-.75V5.999c0-.414.336-.75.75-.75h8.024c.2592 0 .5.1338.6367.3545a.748.748 0 0 1 .0356.7275l-1.3286 2.6934 1.3306 2.7344a.749.749 0 0 1-.0386.7256.749.749 0 0 1-.6357.3525m-7.2739-1.5h6.0747l-.9668-1.9864a.749.749 0 0 1 .002-.6602l.9575-1.9414h-6.0674z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "none",
          d: "M46.5247 44.0012H17.6645l10.26-18.3 4.18-7.45c1.34 2.39 2.6 4.64 3.83 6.83v.01c3.48 6.2 6.6803 11.92 10.5902 18.91"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M46.5244 44.751H17.6646a.7507.7507 0 0 1-.6543-1.1172l14.4399-25.75a.75.75 0 0 1 .6543-.3828.75.75 0 0 1 .6543.3838l3.8296 6.829a.7.7 0 0 1 .0376.0762c3.4658 6.1748 6.6567 11.88 10.5532 18.8448a.75.75 0 0 1-.6548 1.1162m-27.5796-1.5h26.3008c-3.6299-6.4893-6.6724-11.9268-9.9648-17.793a.8.8 0 0 1-.0376-.0762l-3.1392-5.5976z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "none",
          d: "m18.3345 29.8212-.0198.05-1.77 3.55-1.53-1.77-1.49 1.77-2.28-3.27c1.9198-3.42 3.4799-6.2 3.64-6.48 1.4 2.51 2.5399 4.53 3.4498 6.15"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M16.5444 34.1709a.75.75 0 0 1-.5674-.2598l-.955-1.1045-.9239 1.0977c-.1508.1768-.3794.2871-.6079.2656a.75.75 0 0 1-.581-.3203l-2.2798-3.2695a.749.749 0 0 1-.0386-.796l1.0303-1.8349c1.4243-2.538 2.482-4.4218 2.6123-4.6504a.751.751 0 0 1 .6514-.3779h.0039a.75.75 0 0 1 .6513.3848 1330 1330 0 0 0 2.7788 4.957l.6695 1.1914a.748.748 0 0 1 .042.6465l-.02.0498-1.7945 3.6055a.75.75 0 0 1-.6714.415m-4.4155-4.0625 1.4517 2.082.8603-1.0224c.1426-.169.3535-.2783.5737-.2666a.75.75 0 0 1 .5674.2597l.7935.918 1.1128-2.2324-.477-.8486a1522 1522 0 0 1-2.129-3.794c-.4687.834-1.1528 2.0527-1.9531 3.4785z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "none",
          d: "M35.9346 25.0812v.01l-2.06 4.12-1.7799-2.06-1.73 2.06-2.4401-3.51 4.1799-7.45c1.34 2.39 2.6 4.64 3.83 6.83"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M33.8745 29.961a.75.75 0 0 1-.5674-.2598l-1.204-1.3936-1.1641 1.3858c-.15.1787-.3623.2832-.6084.2666a.748.748 0 0 1-.5816-.3213l-2.4404-3.5098a.75.75 0 0 1-.0386-.795l4.1802-7.4501a.75.75 0 0 1 .6543-.3828.75.75 0 0 1 .6543.3838l3.8296 6.829a.75.75 0 0 1 .0962.3673v.0097a.75.75 0 0 1-.0791.335l-2.06 4.1201a.75.75 0 0 1-.671.415m-5.0664-4.3028 1.6128 2.3193 1.0996-1.3085a.752.752 0 0 1 .5689-.2676c.2246.038.4292.0937.5727.2597l1.0444 1.208 1.3819-2.7636-2.9844-5.3213z"
        }
      ),
      /* @__PURE__ */ l("path", { fill: "none", d: "m39.612 39.839.089.16" }),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M39.7017 40.749a.75.75 0 0 1-.6553-.3848l-.0894-.1601c-.2021-.3613-.0722-.8184.2896-1.0205.3618-.1992.8183-.0723 1.02.29l.0894.1602c.2021.3613.0722.8183-.2896 1.0205a.746.746 0 0 1-.3647.0947"
        }
      ),
      /* @__PURE__ */ l("path", { fill: "none", d: "m36.249 33.836 1.927 3.44" }),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M38.1768 38.0264a.748.748 0 0 1-.6548-.3838l-1.9273-3.4404c-.2026-.3614-.0737-.8184.2876-1.0206s.8189-.0742 1.021.2881l1.9273 3.4405a.7493.7493 0 0 1-.2876 1.0205.74.74 0 0 1-.3662.0957"
        }
      )
    ]
  }
);
export {
  i as default
};
